import { Button, HStack, Heading, Image } from "@chakra-ui/react";
import { FC } from "react";

interface Props {
  onOpenAppClick: () => void;
}

const OpenInAppHeader: FC<Props> = ({ onOpenAppClick }) => {
  return (
    <HStack
      width="100%"
      minHeight="56px"
      alignItems="center"
      px={4}
      pr={6}
      borderBottom="1px solid"
      borderColor="gray.200"
    >
      <Image
        boxSize="24px"
        src="/icons/reclaim-app.svg"
        alt="get reclaim app"
        objectFit="contain"
        mx={1}
        borderRadius="8px"
      />

      <Heading as="h2" fontSize="md" flex={1}>
        Reclaim
      </Heading>

      <Button variant="unstyled" color="#332FED" fontSize="13px" onClick={onOpenAppClick}>
        Open app
      </Button>
    </HStack>
  );
};

export default OpenInAppHeader;
